export type RoleAssignmentRoleModelRoleType =
    (typeof RoleAssignmentRoleModelRoleType)[keyof typeof RoleAssignmentRoleModelRoleType];

export const RoleAssignmentRoleModelRoleType = {
    GroupIdentityRole: 'GroupIdentityRole',
    ApiResourceRole: 'ApiResourceRole',
} as const;
